module.exports = "/static/js/9b6cf45fb0add2bf5914c52404316488.png";